export default function getEducationSlug(text){
    return `/${text?.toLowerCase()
        .replace(/ /g,'-')
        .replace(/[^\w-]+/g,'')}`;
}